import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import VueI18n from "vue-i18n";
import { Notification, MessageBox } from "element-ui";
import { ElixioConnectPlugin, getApiClient } from "@latactik/elixio-connect-components-vue2";
import "@latactik/elixio-connect-components-vue2/dist/elixio-connect-vue2.css";

//plugins
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import VueMoment from "vue-moment";
import { i18n } from "./plugins/i18n";
import timeZoneDateFormat from "./plugins/timeZoneDateFormat";

import "./assets/css/style.css";

// router&store setup
import router from "./router";
import store from "./store";
import auth from "./plugins/auth";
import formatCurrency from "./plugins/formatCurrency";
import objectRoute from "./plugins/objectRoute";
import objectDenomination from "./plugins/objectDenomination";
import flatPickrLocale from "./plugins/flatPickrLocale";
import fillUserOrganizationData from "./plugins/fillUserOrganizationData";
import fillUserResellerData from "./plugins/fillUserResellerData";
import showRequestError from "./plugins/showRequestError";
import formatDate from "./plugins/formatDate";
import numberFormat from "./plugins/numberFormat";
import convertDateToUtc from "./plugins/convertDateToUtc";
import VueScrollTo from "vue-scrollto";

const moment = require("moment");
require("moment/locale/fr");

Vue.use(require("vue-moment"), {
  moment,
});

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(auth);
Vue.use(VueMeta, { keyName: "head" });
Vue.use(VueI18n);
Vue.use(formatCurrency);
Vue.use(objectRoute);
Vue.use(objectDenomination);
Vue.use(flatPickrLocale);
Vue.use(fillUserOrganizationData);
Vue.use(fillUserResellerData);
Vue.use(showRequestError);
Vue.use(formatDate);
Vue.use(numberFormat);
Vue.use(convertDateToUtc);
Vue.use(timeZoneDateFormat);
Vue.use(ElixioConnectPlugin, {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  locale: "fr",
  notify: function (message, type) {
    Notification({
      message: message,
      type: type === "danger" ? "error" : type || "info",
      duration: 5000,
    });
  },
  confirm: function (message, options) {
    return MessageBox.confirm(message, "", {
      confirmButtonText: (options && options.confirmButtonText) || "Confirmer",
      cancelButtonText: "Annuler",
      type: (options && options.icon) || "warning",
    })
      .then(function () { return true; })
      .catch(function () { return false; });
  },
});

// Ajouter le token d'auth à l'axios du package ElixioConnect
getApiClient().interceptors.request.use(function (config) {
  var token = localStorage.getItem("vue-authenticate.vueauth_access_token");
  if (token) config.headers.Authorization = "Bearer " + token;
  return config;
});

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

axios.interceptors.request.use(
  (config) => {
    const globalOrganization =
      store.getters["organizations/globalOrganization"];
    if (config.method == "get") {
      if (globalOrganization?.id) {
        if (config.params) {
          if (config.params.filter) {
            config.params.filter.id = globalOrganization.id;
          }
        }
      }
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   render: h => h(App),
//   router
// });
/* eslint-disable no-new */

const app = new Vue({
  i18n: i18n,
  router: router,
  store: store,
  el: "#app",
  render: (h) => h(App),
});

store.$app = app;
